import BaseModelAPI from '../BaseModelAPI';

export default class BillOfProcess extends BaseModelAPI {
	static entity = 'billofprocess';
	static entityName = 'billofprocess';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.billOfProcessNumber = '';
			this.billOfProcessPartTypeId = '';
			this.billOfProcessPartType = {};
			this.partNumberId = '';
			this.partNumber = {};
			this.partName = '';
			this.nextProcessId = '';
			this.nextProcess = {};
			this.billOfProcessDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async GetWorkOrderProcessDetail(this_, id) {
		return this_.$http.get(`${this.entityName}/GetWorkOrderProcessDetail/${id}`)
			.then(response => {
				return response.data;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}
}